namespace Areas.Dialogs.CreateEmployeeAccrual {
    "use strict";

    export class CreateEmployeeAccrualDialog extends Areas.BaseDialog {
        employeeId: number; 

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("CreateEmployeeAccrual", closeHandler, parameters, () => {
                this.employeeId = parameters.employeeId;
            })
        }

        protected ok = (e: any) => {
            const form = $("#CreateEmployeeAccrualForm").dxForm("instance");
            const result = form.validate();

            if (result.isValid) {
                this.saveActivity(this, form);
           }
        }

        saveActivity(that: any, form: DevExpress.ui.dxForm) {
            const data = form.option("formData");
            data.employeeId = this.employeeId;
            const jsonData = JSON.stringify(form.option("formData"));
            const url = "/Dialog/CreateEmployeeAccrual/POST";
            
            sendRequest(url, jsonData, "POST").done(() => { this.close(DialogResult.Ok, null); });
        }
    }

}
